import "styles/popup/popup.scss";

const LoadingPopup = () => {
  return (
    <div className="newStyle">
      <section id="loadingPopup" className="loadingPopup popupContainer d-flex a-center j-center d-none">
        <div className="loadingRolling">
          <div className="loadingBox">
            <div></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoadingPopup;